import { Chip } from "@mui/material";

export const CategoryPill = ({ foodCategory }: { foodCategory: String; }) => {

  if (foodCategory === "") return null;

  return (
    <Chip
      label={foodCategory}
      sx={{
        backgroundColor: '#A6C48A',
        color: '#000',
        marginRight: 8,
        marginBottom: 8,
        margin: "4px",
        borderRadius: '16px',
        fontWeight: 'bold',
        fontSize: '0.8rem',
      }} 
    />
  );
};